
import { useTranslation } from "react-i18next";
import { Outlet } from "react-router";
import { useEffect } from "react";
import { useNavigate } from "react-router";
import useAppStore from "../../store/appStore";
import useAuthStore from "../../store/authStore";
import { Role } from "@/model/entities";

const AuthLayout = () => {
  const { t, i18n } = useTranslation();
  const { darkMode } = useAppStore();
  const { user, userRole } = useAuthStore();
  const navigate = useNavigate();

  useEffect(() => {
    if (user) {
      switch (userRole) {
        case Role.ADMIN:
          navigate("/admin/dashboard");
          break;
        case Role.OWNER:
          navigate("/manager");
          break;
        default:
          navigate("/");
      }
    }
  }, [user, userRole, navigate]);

  const isRTL = i18n.dir() === "rtl";

  // const toggleLanguage = () => {
  //   const newLanguage = language === "he" ? "en" : "he";
  //   setLanguage(newLanguage);
  //   i18n.changeLanguage(newLanguage);
  // };

  return (
    <>
      {/* Navigation Bar */}
      <nav className={`flex justify-between items-center py-4 ${darkMode ? 'bg-gray-800' : 'bg-white'}`}>
        <h1 className="text-2xl font-bold text-[#2C3E50] dark:text-white">
          {t("platformTitle")}
        </h1>
        <div className="flex gap-2">
          {/* <Button
            variant="ghost"
            size="sm"
            onClick={toggleDarkMode}
            className="text-gray-500 dark:text-gray-400 hover:text-gray-700 dark:hover:text-gray-200"
          >
            {darkMode ? <Sun size={18} /> : <Moon size={18} />}
          </Button> */}
          {/* <Button
            variant="ghost"
            size="sm"
            onClick={toggleLanguage}
            className="text-gray-500 dark:text-gray-400 hover:text-gray-700 dark:hover:text-gray-200"
          >
            🌍 {language}
          </Button> */}
        </div>
      </nav>
      <div
        className={`min-h-screen ${
          darkMode ? "dark bg-gray-900" : "bg-gray-50"
        }`}
        dir={isRTL ? "rtl" : "ltr"}
      >
        <div className="container mx-auto px-4 h-screen flex items-center justify-center">
          <div className="w-full max-w-6xl bg-white dark:bg-gray-800 rounded-2xl shadow-xl overflow-hidden flex flex-col lg:flex-row">
            {/* Left Side - Hero Image */}
            <div className="relative lg:w-1/2 hidden lg:block">
              <img
                src="https://images.unsplash.com/photo-1552566626-52f8b828add9?auto=format&fit=crop&q=80"
                alt="Restaurant owner using tablet"
                className="absolute inset-0 w-full h-full object-cover"
              />
              <div className="absolute inset-0 bg-gradient-to-r from-[#2C3E50]/90 to-[#2C3E50]/70 flex items-center justify-center">
                <div className="px-12 text-white">
                  <h1 className="text-4xl font-bold mb-6">
                    {t("platformTitle")}
                  </h1>
                  <p className="text-lg">{t("platformDesc")}</p>
                </div>
              </div>
            </div>

            {/* Right Side - Auth Form */}
            <div className="lg:w-1/2 p-8 lg:p-12">
              <div className="flex justify-between items-center mb-8">
                {/* <h2 className="text-3xl font-bold text-[#2C3E50] dark:text-white">
                  {title}
                </h2>
                <div className="flex gap-2">
                  <button
                    onClick={toggleLanguage}
                    className="p-2 rounded-full hover:bg-gray-100 dark:hover:bg-gray-700"
                  >
                    <Languages className="h-5 w-5" />
                  </button>
                  <button
                    onClick={toggleDarkMode}
                    className="p-2 rounded-full hover:bg-gray-100 dark:hover:bg-gray-700"
                  >
                    {darkMode ? '🌞' : '🌙'}
                  </button>
                </div> */}
              </div>
              <Outlet />
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default AuthLayout;
